import { QueryClient } from '@tanstack/react-query';

// Configurazione QueryClient ottimizzata per l'app Wishlist SSO
export const createQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // I dati rimangono "freschi" per 5 minuti
        staleTime: 5 * 60 * 1000,
        
        // Cache in memoria per 10 minuti
        gcTime: 10 * 60 * 1000,
        
        // Logica di retry intelligente
        retry: (failureCount, error: any) => {
          // Non riprovare per errori 4xx (client errors)
          if (error?.response?.status >= 400 && error?.response?.status < 500) {
            return false;
          }
          // Riprova massimo 2 volte per altri errori (5xx, network, etc.)
          return failureCount < 2;
        },
        
        // Non refetch automatico quando la finestra riprende focus
        // Evita chiamate non necessarie durante l'uso normale dell'app
        refetchOnWindowFocus: false,
        
        // Non refetch automatico quando si riconnette
        refetchOnReconnect: false,
        
        // Non refetch automatico quando il componente si monta
        refetchOnMount: true,
      },
      mutations: {
        // Non riprovare le mutazioni automaticamente
        // Le mutazioni sono operazioni critiche, meglio gestirle manualmente
        retry: false,
        
        // Timeout per le mutazioni (30 secondi)
        networkMode: 'online',
      },
    },
  });
};

// Configurazioni specifiche per diversi tipi di query
export const queryConfigs = {
  // Configurazione per query di sessione utente
  userSession: {
    staleTime: 2 * 60 * 1000, // 2 minuti per dati di sessione
    gcTime: 5 * 60 * 1000,    // 5 minuti in cache
    retry: 1,                 // Solo 1 retry per errori di sessione
  },
  
  // Configurazione per query di prodotti
  products: {
    staleTime: 10 * 60 * 1000, // 10 minuti per catalogo prodotti
    gcTime: 30 * 60 * 1000,    // 30 minuti in cache
    retry: 2,                  // 2 retry per prodotti
  },
  
  // Configurazione per mutazioni di ordini
  orders: {
    retry: false,              // Nessun retry per ordini
  },
};

// Query keys costanti per evitare duplicazioni
export const queryKeys = {
  userSession: ['user-session'] as const,
  products: ['products'] as const,
  orders: ['orders'] as const,
  orderDetails: (orderId: string) => ['order-details', orderId] as const,
} as const; 